import React from 'react';
import './Card.css';
import PurpleStar from '../../assets/purple_star.svg';
import OrangeCheck from '../../assets/orange_check.svg';

const Card = ({ text, isSelected, onClick }) => {
  // Constrói a lista de classes dinamicamente
  const cardClasses = `challenge-card ${isSelected ? 'selected' : ''}`;

  return (
    <button className={cardClasses} onClick={onClick}>
      {/* <span className="card-icon">
        {isSelected ? <img src={OrangeCheck} alt="Check laranja" /> : <img src={PurpleStar} alt="Ícone de estrela" />}
      </span> */}
      <img src={isSelected ? OrangeCheck : PurpleStar} alt="Ícone de estrela" className={isSelected ? "check-icon" : "star-icon"} />
      <span className="card-text">{text}</span>
    </button>
  );
};

export default Card;